import http from '../../api/http';
/**
 * 一卡通信息查询
 */
export const getAccInfo = (params) => http("get", '/settlement/campus/userInfo', params)
/**
 * 关闭一卡通免密
 */
export const closeCardFree = (params) => http("post", '/settlement/campus/agreement/close?userId=' + params.userId + '&projectId=' + params.projectId + '&loginCode=' + params.loginCode
    + '&telPhone=' + params.telPhone + '&accountId=' + params.accountId
)